<div [ngClass]="{ checked: checked }" class="indicator"></div>
